import {Component, inject, OnInit} from '@angular/core';
import {CarrouselGovCoComponent} from "../carrousel-gov-co/carrousel-gov-co.component";
import {SedeElectronicaNoticiasComponent} from "../sede-electronica-noticias/sede-electronica-noticias.component";
import {CardModule} from "primeng/card";
import {ButtonDirective} from "primeng/button";
import {OptionCarousel} from "../../../../shared/interfaces/sede_electronica";
import {NgIf} from "@angular/common";
import {Router} from "@angular/router";

@Component({
  selector: 'app-sede-electronica-home',
  standalone: true,
  imports: [
    CarrouselGovCoComponent,
    SedeElectronicaNoticiasComponent,
    CardModule,
    ButtonDirective,
    NgIf,
  ],
  templateUrl: './sede-electronica-home.component.html',
  styleUrl: './sede-electronica-home.component.scss'
})
export class SedeElectronicaHomeComponent implements OnInit {


  private readonly router: Router = inject(Router);
  cards: OptionCarousel[] = [];

  ngOnInit(): void {
    this.initializeCards();
  }

  private initializeCards(): void {
    this.cards = [
      {
        title: 'Trámites y Servicios',
        description: 'Aquí encontrará información detallada sobre los procedimientos ' +
          'que se pueden llevar a cabo, así como los requisitos necesarios para cada uno de ellos.',
        images: [
          {
            src: 'assets/img/svg/gov-icon-main-tramiservicios-0.svg',
            alt: 'Trámites y Servicios',
            class: '  icon-default ',
            ngStyle: {'max-width': '100%'},
            default:true
          },
          {
            src: 'assets/img/svg/gov-icon-main-tramiservicios-1.svg',
            alt: 'Trámites y Servicios',
            class: ' icon-active',
            ngStyle: {'max-width': '100%'}
          },
        ],
        button: {
          label: 'Ver Trámites',
          class: 'p-button-rounded  sm:w-auto gradient-button-blue flex justify-content-center',
          icon: 'pi pi-angle-right ml-2',
          onClick: (event) => this.redirectTo('consulta'),
        }
      },
      {
        title: 'Canales de atención',
        description: 'Estos canales han sido diseñados para garantizar una comunicación eficiente y efectiva,' +
          ' permitiéndole acceder a la información que necesite de manera oportuna.',
        images: [
          {
            src: 'assets/img/svg/gov-icon-main-canalatenx-0.svg',
            alt: 'Noticias y Actualidad',
            class: '  icon-default',
            ngStyle: {'max-width': '100%'},
            default: true
          }, {
            src: 'assets/img/svg/gov-icon-main-canalatenx-1.svg',
            alt: 'Noticias y Actualidad',
            class: ' icon-active',
            ngStyle: {'max-width': '100%'}
          }
        ],
        button: {
          label: 'Conoce los Canales',
          class: 'p-button-rounded  sm:w-auto gradient-button-blue flex justify-content-center',
          icon: 'pi pi-angle-right ml-2',
          onClick: (event) => {
            console.log("Redirigiendo a Noticias y Actualidad");
            // Aquí puedes agregar la lógica para redirigir al usuario a la página de noticias y actualidad
          }
        }
      },
      {
        title: 'PQRSDF',
        description: 'Haga Peticiones, Quejas, Reclamos, Sugerencias, Denuncias ' +
          'o Felicite y de seguimiento al estado de cada solicitud,' +
          ' para una experiencia en línea pensada para Usted.',
        images: [
          {
            src: 'assets/img/svg/gov-icon-main-pqrsd-0.svg',
            alt: 'PQRSDF',
            class: ' icon-default',
            ngStyle: {'max-width': '100%'},
            default: true
          }, {
            src: 'assets/img/svg/gov-icon-main-pqrsd-1.svg',
            alt: 'PQRSDF',
            class: ' icon-active',
            ngStyle: {'max-width': '100%'}
          },
        ],
        button: {
          label: 'Empezar',
          class: 'p-button-rounded  sm:w-auto gradient-button-blue flex justify-content-center',
          icon: 'pi pi-angle-right ml-2',
          onClick: (event) => this.redirectTo('pqrsd'),
        }
      }
    ];
  }

  redirectTo(section:string){
    this.router.navigate(['/sede-electronica',section]).then();
  }
  protected readonly Array = Array;
}
